import React, { useState } from 'react';
import api from '../services/api';

// =====================================================================
// 🧩 SUB-COMPONENTES DE DELEGACIÓN (VISTAS PURAS)
// =====================================================================

const PasoDatosPersonales = ({ formData, onChange }) => (
    <div className="space-y-4 animate-fade-in">
        <h3 className="text-sm font-black text-slate-400 uppercase tracking-wider border-b border-slate-100 pb-2">Filiación Básica</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input type="text" placeholder="Nombre *" value={formData.nombre} onChange={e => onChange('nombre', e.target.value)} className="p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium focus:bg-white focus:outline-none focus:border-clinica-primary transition-all" />
            <input type="text" placeholder="Apellidos *" value={formData.apellidos} onChange={e => onChange('apellidos', e.target.value)} className="p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium focus:bg-white focus:outline-none focus:border-clinica-primary transition-all" />
            <input type="text" placeholder="DNI / NIE *" value={formData.dni} onChange={e => onChange('dni', e.target.value)} className="p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium focus:bg-white focus:outline-none focus:border-clinica-primary transition-all" />
            <input type="date" value={formData.fechaNacimiento} onChange={e => onChange('fechaNacimiento', e.target.value)} className="p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium text-slate-600 focus:bg-white focus:outline-none focus:border-clinica-primary transition-all" title="Fecha de Nacimiento" />
            <input type="text" placeholder="Teléfono *" value={formData.telefono} onChange={e => onChange('telefono', e.target.value)} className="p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium focus:bg-white focus:outline-none focus:border-clinica-primary transition-all" />
            <input type="email" placeholder="Email (Opcional)" value={formData.email} onChange={e => onChange('email', e.target.value)} className="p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium focus:bg-white focus:outline-none focus:border-clinica-primary transition-all" />
            <input type="text" placeholder="Dirección Completa" value={formData.direccion} onChange={e => onChange('direccion', e.target.value)} className="col-span-1 md:col-span-2 p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium focus:bg-white focus:outline-none focus:border-clinica-primary transition-all" />

            <div className="col-span-1 md:col-span-2">
                <label htmlFor="seguroMedico" className="block text-xs font-bold text-slate-500 mb-1 ml-1">Seguro Médico / Cobertura *</label>
                <select id="seguroMedico" value={formData.seguroMedico} onChange={e => onChange('seguroMedico', e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium focus:bg-white focus:outline-none focus:border-clinica-primary transition-all text-slate-700">
                    <option value="ninguno">Ninguno / Sanidad Pública</option>
                    <option value="privado">Seguro Privado</option>
                    <option value="mutua">Mutua Laboral</option>
                    <option value="publico">Sanidad Pública (Especificar)</option>
                </select>
            </div>
        </div>
    </div>
);

const PasoDatosMedicos = ({ formData, onChange }) => (
    <div className="space-y-4 animate-fade-in">
        <h3 className="text-sm font-black text-slate-400 uppercase tracking-wider border-b border-slate-100 pb-2">Historial Clínico Inicial</h3>
        <div className="space-y-4">
            <select value={formData.grupoSanguineo} onChange={e => onChange('grupoSanguineo', e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-bold text-slate-700 focus:bg-white focus:outline-none focus:border-clinica-primary transition-all">
                <option value="Desconocido">Grupo Sanguíneo: Desconocido</option>
                {['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'].map(g => <option key={g} value={g}>{g}</option>)}
            </select>

            <div>
                <label htmlFor="alergias" className="block text-xs font-bold text-slate-500 mb-1 ml-1">Alergias Conocidas</label>
                <textarea id="alergias" placeholder="Ej. Penicilina, Polen (Separadas por comas)..." value={formData.alergias} onChange={e => onChange('alergias', e.target.value)} className="w-full p-3 bg-orange-50/30 border border-orange-200 rounded-xl text-sm font-medium h-16 resize-none focus:bg-white focus:outline-none focus:border-orange-400 transition-all" />
            </div>

            <div>
                <label htmlFor="antecedentes" className="block text-xs font-bold text-slate-500 mb-1 ml-1">Patologías Crónicas / Antecedentes</label>
                <textarea id="antecedentes" placeholder="Ej. Hipertensión, Diabetes..." value={formData.antecedentes} onChange={e => onChange('antecedentes', e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium h-16 resize-none focus:bg-white focus:outline-none focus:border-clinica-primary transition-all" />
            </div>

            <div>
                <label htmlFor="medicacion" className="block text-xs font-bold text-slate-500 mb-1 ml-1">Medicación Habitual</label>
                <textarea id="medicacion" placeholder="Ej. Ibuprofeno 600mg, Omeprazol..." value={formData.medicacion} onChange={e => onChange('medicacion', e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm font-medium h-16 resize-none focus:bg-white focus:outline-none focus:border-clinica-primary transition-all" />
            </div>
        </div>
    </div>
);

// =====================================================================
// 🏢 CONTENEDOR PRINCIPAL: ALTA HOSPITALARIA
// =====================================================================
const NuevoPaciente = ({ open, onClose, onSuccess }) => {
    const [step, setStep] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const [formData, setFormData] = useState({
        nombre: '', apellidos: '', dni: '', fechaNacimiento: '',
        telefono: '', email: '', direccion: '', seguroMedico: 'ninguno',
        alergias: '', antecedentes: '', medicacion: '', grupoSanguineo: 'Desconocido'
    });

    const handleFieldChange = (campo, valor) => {
        setFormData(prev => ({ ...prev, [campo]: valor }));
        if (errorMsg) setErrorMsg('');
    };

    const handleCompletarAlta = async () => {
        if (!formData.nombre || !formData.apellidos || !formData.dni) {
            return setErrorMsg('Los campos Nombre, Apellidos y DNI son obligatorios.');
        }
        setIsSubmitting(true);
        setErrorMsg('');

        try {
            const response = await api.post('/pacientes', formData);
            if (onSuccess) onSuccess(response.data?.id || response?.id);

            // Limpiamos todo si hay éxito
            setStep(0);
            setFormData({
                nombre: '', apellidos: '', dni: '', fechaNacimiento: '',
                telefono: '', email: '', direccion: '', seguroMedico: 'ninguno',
                alergias: '', antecedentes: '', medicacion: '', grupoSanguineo: 'Desconocido'
            });
            if (onClose) onClose();

        } catch (error) {
            // 🚀 FIX APLICADO: Leemos error.message tal y como lo escupe el api.js
            // Así capturamos el mensaje exacto: "Fallo de consistencia: El DNI ya pertenece..."
            setErrorMsg(error.message || 'Error al registrar al paciente. Verifique los datos.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
            <div className="w-full max-w-2xl bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col max-h-[95vh]">
                <div className="flex items-center justify-between px-6 py-5 border-b border-slate-100 bg-slate-50/50">
                    <h2 className="text-xl font-black text-slate-900">Alta de Nuevo Paciente</h2>
                    <span className="px-3 py-1 bg-white border border-slate-200 text-slate-500 rounded-full text-xs font-bold uppercase tracking-wider shadow-sm">Paso {step + 1} de 2</span>
                </div>

                <div className="p-6 overflow-y-auto">
                    {/* 🛡️ BANNER DE ERROR (Aquí se mostrará el bloqueo de DNI de tu backend) */}
                    {errorMsg && (
                        <div className="mb-5 p-4 bg-red-50 text-red-700 text-sm font-bold rounded-xl border border-red-200 shadow-sm animate-fade-in flex items-start gap-3">
                            <svg className="w-5 h-5 shrink-0 mt-0.5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
                            <span className="leading-relaxed">{errorMsg}</span>
                        </div>
                    )}

                    {step === 0 ? <PasoDatosPersonales formData={formData} onChange={handleFieldChange} /> : <PasoDatosMedicos formData={formData} onChange={handleFieldChange} />}
                </div>

                <div className="flex justify-end gap-3 px-6 py-4 border-t border-slate-100 bg-slate-50 mt-auto">
                    <button onClick={onClose} disabled={isSubmitting} className="px-5 py-2.5 text-sm font-bold text-slate-500 hover:text-slate-700 transition-colors">Cancelar</button>
                    {step > 0 && <button onClick={() => setStep(step - 1)} disabled={isSubmitting} className="px-5 py-2.5 text-sm font-bold text-slate-700 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 transition-colors shadow-sm">Atrás</button>}
                    <button onClick={() => step === 1 ? handleCompletarAlta() : setStep(step + 1)} disabled={isSubmitting} className="px-6 py-2.5 bg-slate-900 text-white text-sm font-bold rounded-xl hover:bg-slate-800 transition-all shadow-md">
                        {isSubmitting ? 'Guardando...' : (step === 1 ? 'Completar Alta' : 'Continuar')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NuevoPaciente;